<template>
  <div class="space-y-6">
    <h2 class="text-2xl font-bold text-gray-800">
      {{ title }}
    </h2>
    <p
      v-if="description"
      class="text-gray-600"
    >
      {{ description }}
    </p>
    
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  description?: string;
}>();
</script>
